import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';
import pick from 'lodash/pick';
import FileUploadCallCardStore from 'stores/files/FileUploadCallCardStore';
import LibraryStore from 'stores/library/LibraryStore';
import SearchStore from 'stores/SearchStore';
import TrendPivotChartStore from 'stores/calls/trend/TrendPivotChartStore';
import CoachingPlaylistStore, {
  PLAYLIST_MODE_TYPE,
  PLAYLIST_VISIBILITY,
} from 'stores/CoachingPlaylistStore';
import {getStringQueryParam} from 'utils/getQueryParam';
import CallsComponent from './CallsComponent';
import SavedSearchActions from 'actions/search/SavedSearchActions';
import CallActions from 'actions/CallActions';
import SearchInputActions from 'actions/search/SearchInputActions';
import TrendPivotChartActions from 'actions/calls/trend/TrendPivotChartActions';

/**
 * CallsComponentContainer is an AltContainer for <CallsComponent/>. It connects
 * SearchStateStore with CallsComponent so that any change towards the current
 * active search, whether it's by search term or other states, can be propagated in
 * time to the <CallsComponent/>
 */
class CallsComponentContainer extends React.Component {
  static getStores() {
    return [
      LibraryStore,
      SearchStore,
      TrendPivotChartStore,
      FileUploadCallCardStore,
      CoachingPlaylistStore,
    ];
  }

  static getPropsFromStores(props) {
    const searchState = SearchStore.getState();
    const libraryTagToDelete = LibraryStore.getState().get('libraryTagToDelete');
    const trendState = TrendPivotChartStore.getState();
    const playlistStore = CoachingPlaylistStore.getState();

    const focusedFileId = getStringQueryParam(props.location, 'fileId');
    const focusedCall = searchState.searchResults.results.find(({id}) => id === focusedFileId);
    const isScorecardToggled = FileUploadCallCardStore.getState().isScorecardToggled;
    const addingCallsToPlaylist =
      playlistStore.visibility !== PLAYLIST_VISIBILITY.hidden &&
      playlistStore.mode === PLAYLIST_MODE_TYPE.ADD_CALLS;

    // Rep is only set when the playlist is visible AND calls are being added.
    const repToSearchFor = addingCallsToPlaylist ? playlistStore.recipient : undefined;

    return {
      isAdvancedSearch: searchState.isAdvancedSearch,
      isSearchingSelf: searchState.isSearchingSelf,
      sortByDate: searchState.sortByDate,
      libraryTagToDelete: libraryTagToDelete,
      searchTerm: searchState.get('searchTerm'),
      showTrendChart: trendState.get('showTrendChart'),
      showTrendButton: !searchState.searchFields.isEmpty(),
      repToSearchFor,
      focusedCall,
      showRepFilterLink: !isScorecardToggled && addingCallsToPlaylist && focusedCall,
      ...pick(FileUploadCallCardStore.getState(), [
        'isScorecardToggled',
        'areScorecardResultsToggled',
      ]),
    };
  }

  componentDidMount() {
    const savedSearchId = this.props.routeParams['savedSearchId'];
    if (savedSearchId) {
      SavedSearchActions.retrieveAndExecuteSavedSearch(savedSearchId);
    }
  }

  render() {
    return (
      <AltContainer
        actions={{
          CallActions,
          SearchInputActions,
          TrendPivotChartActions,
        }}>
        <CallsComponent {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(CallsComponentContainer);
